<template>
  <div
    :class="[
      $q.screen.width < 600 ? 'col-12 q-mb-md' : 'col-6',
      { 'q-pa-sm': !isColumnLayout && $q.screen.width >= 600 },
    ]"
  >
    <q-card
      :class="[
        'post-card cursor-pointer full-height q-pb-md overflow-hidden',
        isColumnLayout ? 'border-radius-0' : 'border-radius-20',
      ]"
      flat
      tag="a"
      :href="post.publicUrl"
    >
      <img
        :src="cover"
        :alt="post.metaFields.coverImageAlt"
        loading="lazy"
        :width="width"
        :height="height"
        class="post-card-image q-mb-md"
      >

      <q-card-section class="q-pb-none q-px-lg">
        <div class="post-date fs-12 q-mb-sm">
          {{ dayjs.unix(post.createdAt.timestamp).format('DD.MM.YYYY') }}
          {{ dayjs.unix(post.createdAt.timestamp).format('HH:mm') }}
        </div>
        <div class="post-title fs-16 q-mb-sm">
          {{ post.title }}
        </div>
      </q-card-section>

      <q-card-section class="post-content q-pt-sm q-px-lg">
        <div v-html="description" />
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import { computed } from 'vue';
import getThumb from 'src/helpers/getThumb';
import { useQuasar } from 'quasar';

const $q = useQuasar();

const props = defineProps({
  post: {
    type: Object,
    default: () => ({}),
  },
  isColumnLayout: {
    type: Boolean,
    default: false,
  },
});

const width = $q.screen.width < 600 ? 330 : 500;
const height = $q.screen.width < 600 ? 240 : 250;

const cover = computed(() => {
  if (!props.post.coverImageGuid?.url) {
    return '/empty-blog-cover.png';
  }

  return getThumb(props.post.coverImageGuid?.url, width, height);
});
const description = computed(() => props.post.metaFields.metaDescription || props.post.excerptContent);
</script>

<style lang="scss" scoped>
.post-card {
  display: block;
  background: var(--blog-card-color, #fff);
  color: inherit;
  text-decoration: inherit;
}
.post-date,
.post-content {
  opacity: 0.5;
}
.post-date {
  line-height: 12px;
}
.post-title {
  overflow: hidden;
  line-height: 22px;
  height: 44px;
}
.post-content {
  line-height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
.post-card-image {
  object-fit: cover;
}
</style>
